<template>
  <v-stepper v-model="e1" vertical>
    <v-stepper-step  :complete="e1 > 1" step="1" class="pb-0">약관 동의</v-stepper-step>
    <v-stepper-content step="1">
      <v-container
        lass="fill-height"
        fluid
      >

        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sx="12"
            md="8"
            lg="5"
            xl="4"
          >
            <v-card>
              <v-card-title>회원가입</v-card-title>

              <v-container fluid>
                <v-card>
                  <v-card-title>이용약관</v-card-title>
                  <v-form
                    ref="termForm"
                    v-model="termsValid"
                  >
                    <v-container
                      class="mb-0"
                      fluid
                    >
                      <v-card>
                        <v-checkbox
                          v-model="allTermCheckbox"
                          label="모두확인, 동의합니다."
                          hide-details
                          class="pa-2 mt-0"
                          @change="onAllTermCheckboxClick"
                          color="primary"
                        >
                        </v-checkbox>
                      </v-card>
                    </v-container>

                    <v-container
                      fluid
                    >
                      <v-card>
                        <v-checkbox
                          v-model="requiredTermCheckbox"
                          label="이용약관 전체동의 (필수)"
                          hide-details
                          :rules="[v => !!v || '약관에 반드시 동의해야합니다.']"
                          class="pa-2 mt-0 mb-0"
                          @change="onRequiredTermCheckboxClick"
                          color="primary"
                        >
                        </v-checkbox>

                         <v-dialog
                          v-for="term in terms"
                          :key="term.name"
                          v-model="term.termDialog"
                          style="display:inline"
                          fullscreen hide-overlay transition="dialog-bottom-transition"
                        >
                          <template v-slot:activator="{ on }">
                            <div
                              class="d-flex justify-space-between pl-6 pr-2 term-button"
                              v-on="on"
                            >
                              <div class="font-weight-light body-2">{{ term.name }}</div>
                              <v-icon>mdi-chevron-right</v-icon>
                            </div>
                          </template>

                          <v-card>
                            <v-toolbar dark color="primary">
                              <v-btn icon dark @click="term.termDialog=false">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </v-toolbar>

                            <component v-bind:is="term.component"></component>

                            <v-card-actions>
                              <v-btn color="primary" text @click="term.termDialog=false">확인</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>

                        <v-divider
                          class="mt-2 md-2"
                        >
                        </v-divider>
                        <v-checkbox
                          v-model="optionalTermCheckbox"
                          label="마케팅 정보 동의 (선택)"
                          hide-details
                          class="px-2 mt-1"
                          @change="onOptionalTermCheckboxClick"
                          color="primary"
                        ></v-checkbox>
                        <p class="caption px-4 pb-2 mt-0 md-0">* 거주지역 부동산 정보를 받아볼 수 있습니다.</p>

                      </v-card>
                      <v-btn
                        :disabled="!termsValid"
                        @click="onContinueClick"
                        color="primary"
                      >
                      다음
                      </v-btn>
                    </v-container>
                  </v-form>

                </v-card>
              </v-container>

            </v-card>
          </v-col>
        </v-row>


      </v-container>
    </v-stepper-content>

    <v-stepper-step :complete="e1 > 2" step="2" class="pb-0">정보 입력</v-stepper-step>
    <v-stepper-content step="2">
      <v-container
      lass="fill-height"
        fluid
      >
        <v-row
            align="center"
            justify="center"
        >
          <v-col
            cols="12"
            sx="12"
            md="8"
            lg="5"
            xl="4"
          >
            <v-card>
              <v-card-title>회원가입</v-card-title>

              <v-container fluid>
                <v-card>
                  <v-card-title class="pb-0">가입정보</v-card-title>
                  <v-form
                    ref="form"
                    v-model="signupValid"
                    @submit.prevent="onSubmitSignup"
                  >
                    <v-container
                      fluid
                    >
                        <v-text-field
                          v-model="name"
                          :rules="nameRules"
                          :success="nameSuccess"
                          label="이름*"
                          required
                          prepend-icon="mdi-account"
                          hide-details
                          class="my-3"
                        >
                        </v-text-field>
                        <v-text-field
                          v-model="email"
                          :rules="emailRules"
                          :success="emailSuccess"
                          label="이메일*"
                          type="email"
                          required
                          prepend-icon="mdi-email"
                          hide-details
                          class="my-3"
                        >
                        </v-text-field>
                        <v-text-field
                          v-model="phone"
                          :rules="phoneRules"
                          :success="phoneSuccess"
                          label="전화번호*"
                          type="text"
                          required
                          @keyup="onPhoneKeyup"
                          prepend-icon="mdi-cellphone-android"
                        >
                        </v-text-field>

                        <v-card-text class="ma-0 mt-5 mb-3 pa-0 body-1">
                          <v-icon>mdi-map-marker</v-icon>
                          가입 경로*
                        </v-card-text>
                        <v-radio-group
                          v-model="from"
                          hide-details
                          class="my-2 px-4"
                          :rules="fromRules"
                        >
                          <v-radio value ="인터넷검색" label="인터넷검색"></v-radio>
                          <v-radio value="블로그" label="블로그"></v-radio>
                          <v-radio value="유튜브" label="유튜브"></v-radio>
                          <v-radio value="강의" label="강의"></v-radio>
                          <v-radio value="페이스북" label="페이스북"></v-radio>
                          <v-radio value="지인추천" label="지인추천"></v-radio>
                          <v-radio value="기타" label="기타"></v-radio>
                          <v-text-field
                            v-if="from === '기타'"
                            v-model="fromETC"
                            :rules="fromETCRules"
                            :success="fromETCSuccess"
                            type="text"
                            class="ma-1 px-4 pt-0"
                          >
                          </v-text-field>
                        </v-radio-group>


                      <v-btn
                        :disabled="!signupValid"
                        type="submit"
                        color="primary"
                      >
                      가입하기
                      </v-btn>
                    </v-container>
                  </v-form>

                </v-card>
              </v-container>

            </v-card>
          </v-col>
        </v-row>
      </v-container>

    </v-stepper-content>

  </v-stepper>


</template>

<script>
import { formUtility } from '../mixins/formUtility.js';
import { api } from '../mixins/api.js';
import jwtParser from '../mixins/jwtParser.js';
import Term01Component from '../components/terms/Term01'
import Term02Component from '../components/terms/Term02'

export default {
  data() {
    return {
      registerToken: '',

      e1: 1,
      termsValid: false,
      signupValid: false,
      allTermCheckbox: false,
      requiredTermCheckbox: false,
      optionalTermCheckbox: false,
      terms: [
         {
          termDialog: false,
          name: '[필수] 전자상거래 약관',
          component: Term01Component
        },
        {
          termDialog: false,
          name: '[필수] 개인정보 약관',
          component: Term02Component
        }
      ],
      // from token
      name:'',
      nameRules: [
        v => !(v === '') || '이름을 입력해주세요.',
        v => this.validName(v) || '잘못된 이름입니다.'
      ],
      email: '',
      emailRules: [
        v => !(v === '') || '이메일을 입력해주세요.',
        v => this.validEmail(v) || '잘못된 이메일 형식입니다.'
      ],
      phone: '',
      phoneRules: [
        v => !(v === '') || '전화번호를 올바르게 입력해주세요.',
        v => v.length === 13,
      ],
      from: '',
      fromRules: [
        v => !(v === '' || v === null) || '가입경로를 입력해주세요.',
        v => v.length > 0,
      ],
      fromETC: '',
      fromETCRules: [
        v => !(v === '' || v === null) || '가입경로를 입력해주세요.',
        v => v.length > 0,
      ]
    }
  },
  async created() {
    this.registerToken = this.$route.query.registerToken;
    const tokenInfo = jwtParser.parseJwt(this.registerToken);
    this.name = tokenInfo.unique_name;
    this.email = tokenInfo.email;
  },
  computed: {
    nameSuccess() {
      return this.validName(this.name);
    },
    emailSuccess() {
      return this.validEmail(this.email);
    },
    phoneSuccess() {
      return this.phone.length === 13;
    },
    fromSuccess() {
      return this.from.length !== null;
    },
    fromETCSuccess() {
      return this.from !== '기타' || (this.fromETC !== null && this.fromETC.length > 0);
    }
  },
  methods: {
    validName(v) {
      return /^[가-힣]{2,4}$|^[a-zA-Z]{2,10}$|^[a-zA-Z]{2,10}\s[a-zA-Z]{2,10}$/.test(v);
    },
    validEmail(v) {
      if (v === '네이버ID@naver.com') {
        alert('잘못된 이메일입니다. 네이버 회원정보 수정을 통해 이메일 정보를 변경해주세요.');
        return false;
      } else {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v);
      }
    },
    onAllTermCheckboxClick() {
      this.requiredTermCheckbox = this.optionalTermCheckbox = this.allTermCheckbox === true;
    },
    onRequiredTermCheckboxClick() {
      this.allTermCheckbox = this.requiredTermCheckbox === true && this.optionalTermCheckbox === true;
    },
    onOptionalTermCheckboxClick() {
      this.allTermCheckbox = this.requiredTermCheckbox === true && this.optionalTermCheckbox === true;
    },
    onContinueClick() {
      this.e1 = 2
    },
    onPhoneKeyup() {
      this.phone = this.getPhoneMask(this.phone);
    },
    async onSubmitSignup() {
      if (this.nameSuccess === false) {
        alert('이름을 올바르게 입력하세요.');
        return;
      } else if (this.emailSuccess === false) {
        alert('이메일이 올바르게 입력하세요.');
        return;
      } else if (this.phoneSuccess === false) {
        alert('전화번호를 올바르게 입력하세요.');
        return;
      } else if (this.fromSuccess === false) {
        alert('가입경로를 올바르게 입력하세요.');
        return;
      } else if (this.$refs.termForm.validate() === false) {
        alert('약관에 동의해야합니다.');
        return;
      }

      const from = this.from !== '기타' ? this.from : this.fromETC;
      const refreshToken = await api.methods.signupApi(this.registerToken, {
        referer: from,
        name: this.name,
        email: this.email,
        phone: this.phone.replace(/[^0-9]/g, ''),
        isTermAgreed: this.optionalTermCheckbox === true ? 1 : 0,
      });

      if (refreshToken !== null) {
        this.$store.commit("setRefreshToken", refreshToken);
      } else {
        alert('회원가입 실패');
        return;
      }
      this.$router.replace('/');
    }
  },
  mixins: [formUtility]
}
</script>

<style scoped>
.term-button:hover {
  cursor: pointer;
}
</style>
